module.exports = __webpack_public_path__ + "img/x-square-grey.6f8b02f7.svg";